export default __webpack_public_path__ + "static/media/slider_horizontal_theme2.39cd19b3.svg";